module.exports = __webpack_public_path__ + "static/media/Manufacturing.ea350138.jpeg";